var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"process-design",style:('display: flex; height:' + _vm.height)},[_c('bpmn-process-designer',_vm._b({ref:"processDesigner",attrs:{"keyboard":"","events":[
      'element.click',
      'connection.added',
      'connection.removed',
      'connection.changed'
    ]},on:{"element-click":_vm.elementClick,"init-finished":_vm.initModeler,"event":_vm.handlerEvent,"save":_vm.onSaveProcess},model:{value:(_vm.xmlString),callback:function ($$v) {_vm.xmlString=$$v},expression:"xmlString"}},'bpmn-process-designer',_vm.controlForm,false)),_c('bmpn-process-penal',{staticClass:"process-panel",attrs:{"bpmn-modeler":_vm.modeler,"prefix":_vm.controlForm.prefix,"appType":_vm.controlForm.appType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }